<template>
  <section
    class="nav-main">
    <div class="site-container site-container-lg">

      <!-- Logo -->
      <div class="row align-middle">
        <div class="logo">
          <logo />
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
    'logo': () => import('../Logo')
  },
  computed: {
    ...mapGetters('window', [
      'isMobile',
      'isTouch'
    ]),
    logo () {
      return 'https://storage.googleapis.com/assets.festfoods.com/images/clickngo/logo-orange.svg'
    }
  },
  data () {
    return {
      now: this.$moment(new Date()).format(),
      openMenu: '',
      toggle: false
    }
  },
  methods: {
    beforeEnter (el) {
      el.style.height = '0'
    },
    enter (el) {
      el.style.height = `${el.scrollHeight}px`
    },
    beforeLeave (el) {
      el.style.height = `${el.scrollHeight}px`
    },
    leave (el) {
      el.style.height = '0'
    }
  }
}
</script>

<style lang="scss">
  .nav-main {
      background-color: $white;
      box-shadow: 0 .4rem .8rem 0 rgba($black, .15);
      display: block;
      position: relative;

      .logo {
        h1 {
          line-height: 0;
          margin: 0;
          padding: 0;
        }

        a {
          padding: 0;

          img {
            @include breakpoint-max(md + 62) {
              width: 80%;
            }
            height: 4.8rem;
          }
        }
    }

    .logo {
        display: block;
    }
  }
</style>
